module.exports = __webpack_public_path__ + "static/media/Normal.84a48c40.svg";